var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchNowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3415V1.64774C0.00438954 1.45371 0.063238 1.26481 0.169825 1.10261C0.276411 0.940417 0.426452 0.811445 0.602814 0.730422C0.788165 0.640066 0.993171 0.597532 1.19917 0.606688C1.40517 0.615843 1.6056 0.676398 1.78221 0.782841L15.4921 9.1317C15.6462 9.21832 15.7744 9.34438 15.8637 9.49695C15.953 9.64952 16 9.82309 16 9.99986C16 10.1766 15.953 10.3502 15.8637 10.5028C15.7744 10.6553 15.6462 10.7814 15.4921 10.868L1.77565 19.2077C1.60896 19.3166 1.41689 19.3803 1.21819 19.3928C1.01948 19.4052 0.820942 19.3658 0.642006 19.2785C0.46307 19.1912 0.309851 19.059 0.197319 18.8948C0.0847863 18.7305 0.0168004 18.5399 0 18.3415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchNowIcon);
export default __webpack_public_path__ + "static/media/watchNowIcon.dd7d0c0515b0f7670edf6d61d767445a.svg";
export { ForwardRef as ReactComponent };